import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Chatbot = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.botpress.cloud/webchat/v2.2/inject.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      // Dev
      // window.botpressWebChat.init({
      //   composerPlaceholder: "Chat with bot",
      //   botConversationDescription: "Get chatbot help",
      //   botId: "deac653f-39d3-4e83-9d53-39f94d0bdfeb",
      //   hostUrl: "https://cdn.botpress.cloud/webchat/v1",
      //   messagingUrl: "https://messaging.botpress.cloud",
      //   clientId: "deac653f-39d3-4e83-9d53-39f94d0bdfeb",
      //   webhookId: "e8e898d8-db7e-4c36-87fd-c6714e30bd22",
      //   lazySocket: true,
      //   themeName: "prism",
      //   frontendVersion: "v1",
      //   showPoweredBy: true,
      //   theme: "prism",
      //   themeColor: "#2C9009",
      //   allowedOrigins: [
      //     "https://mashhad.ntww.com",
      //     "https://mashhaddev.ntww.com",
      //   ],
      // });

      // Staging
      window.botpress.init({
        botId: "deac653f-39d3-4e83-9d53-39f94d0bdfeb",
        configuration: {
          website: {},
          email: {},
          phone: {},
          termsOfService: {},
          privacyPolicy: {},
          color: "#3B82F6",
          variant: "solid",
          themeMode: "light",
          fontFamily: "inter",
          radius: 1,
        },
        clientId: "0735f1b4-9424-4719-9279-bde6014cd46d",
        // composerPlaceholder: "Chat with المشهد الحضري",
        // botConversationDescription: "أمانة منطقة الرياض",
        // hostUrl: "https://cdn.botpress.cloud/webchat/v2.2",
        // messagingUrl: "https://messaging.botpress.cloud",
        // webhookId: "854af806-96a1-42f5-971a-b61d3d4853b3",
        // lazySocket: true,
        // themeName: "galaxy",
        // botName: "المشهد الحضري",
        // frontendVersion: "v2.2",
        // showBotInfoPage: true,
        // enableConversationDeletion: true,
        // showPoweredBy: true,
        // theme: "galaxy",
        // themeColor: "#2563eb",
        allowedOrigins: [
          "https://mashhad.ntww.com",
          "https://mashhaddev.ntww.com",
        ],
      });
    };
  }, []);

  return <div id='webchat' />;
};

export default Chatbot;
